module.exports = __webpack_public_path__ + "img/h_elg.e66a0539.jpg";